module.exports = __webpack_public_path__ + "img/17.ff4e17b0.jpg";